import React from 'react';
import styled from 'styled-components';

import Tag from 'antd/es/tag';

import doorState from 'config/doorState';

const tagStylesByState = {
  [doorState.UNLOADING]: `
    color: #52C41A;
    background: #F6FFED;
    border: 1px solid #B7EB8F;
  `,
  [doorState.LOADING]: `
    color: #52C41A;
    background: #F6FFED;
    border: 1px solid #B7EB8F;
  `,
  [doorState.EMPTY]: `
    color: #828C94;
    background: #FAFBFC;
    border: 1px solid #EFF2F5;
  `,
  [doorState.STOPPED]: `
    color: #F5222D;
    background: #FFF1F0;
    border: 1px solid #FFA39E;
  `,
  [doorState.NOT_STARTED]: `
    color: #232526;
    background: #FAFBFC;
    border: 1px solid #E4E8ED;
  `,
  [doorState.FINISHED]: `
    color: #1560AD;
    background: #F0F5FF;
    border: 1px solid #ADC6FF;
  `,
  MAINTENANCE: `
    color: #828C94;
    background: #FAFBFC;
    border: 1px solid #EFF2F5;
  `,
  CAMERA_OFFLINE: `
    color: #828C94;
    background: #FAFBFC;
    border: 1px solid #EFF2F5;
  `,
};

const StyledTag = styled(Tag)`
  text-transform: capitalize;
  box-sizing: border-box;
  border-radius: 4px;
  ${props => tagStylesByState[props.status]}
`;

const StatusTag = ({ status, children, isMaintenance, maintenance, maintenanceMode, door, item, container }) => {
  const isMaint = !!(isMaintenance || maintenance || maintenanceMode ||
    (door && door.maintenance_mode === 1) ||
    (item && item.maintenance_mode === 1) ||
    (container && container.maintenance_mode === 1));
  const finalStatus = isMaint ? 'MAINTENANCE' : status;

  let value;
  if (finalStatus === 'COMPLETE') {
    value = 'Finished';
  } else if (finalStatus === 'UNLOADING' || finalStatus === 'LOADING') {
    value = 'In Progress';
  } else {
    value = finalStatus.toLowerCase().replace('_', ' ');
  }

  return (
    <StyledTag status={finalStatus}>
      {
        !!children
          ? children
          : value
      }
    </StyledTag>
  );
}

export default StatusTag;
